const softwareStatus = {
  bindings: {
    train: '<',
    topologyUpdatedTime: '<',
    isTrainConnected: '<',
  },
  templateUrl: '/modules/configurationManagement/software-status/software-status.html',
  controller: 'SoftwareStatusController',
};

angular
  .module('configuration-management.module')
  .component('softwareStatus', softwareStatus)
  .config(function($stateProvider) {
    $stateProvider.state('train.swstatus', {
      url: '/sw-status',
      views: {
        'traintab@train': 'softwareStatus',
      },
    });
  });